<template>
	<AppDialog width="412" :closeTop="'-30'" :closeRight="'-10'" dialogName="EditButtonDesignDialog">
		<Col class="dialog-content rounded pt-6 px-7 pb-5 flex-justify-space-between">
			<ButtonDropdownInputForm
				:iconColor.sync="iconColor"
				:iconName.sync="iconName"
				:tooltipText.sync="tooltip"
				:mainScreenText.sync="mainScreenText"
			/>
			<Row class="flex-centerize">
				<AnemicButton
					tile
					@click="save"
					:loading="isLoading"
					class="save-button pa-0"
					:disabled="!isFormValid || isLoading"
					:class="{ disabled: !isFormValid || isLoading }"
				>
					Save
				</AnemicButton>
			</Row>
		</Col>
	</AppDialog>
</template>
<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import { updateButtonDropdown } from '@/store/modules/buttonDropdowns/actions';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
// import DropdownTextStyleEditor from '@/components/BlockEditor/ButtonEditorDrawer/tabs/DropdownTextStyleEditor.vue';
import { useButtonDropdown } from '@/store/modules/buttonDropdowns/getters';
import ButtonDropdownInputForm from '../CreationWizard/Steps/FillButtonDropdownData/ButtonDropdownInputForm.vue';
export default {
	name: 'EditButtonDropdownDesignDialog',
	components: { AppDialog /*, DropdownTextStyleEditor*/, ButtonDropdownInputForm },
	props: {
		buttonDropdownId: { type: Number },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		...mapGettersShorthand({ useButtonDropdown }),
		buttonDropdown() {
			return this.useButtonDropdown(this.buttonDropdownId);
		},
		buttonDropdownIconName() {
			return this.buttonDropdown.icon_name;
		},
		hasIcon() {
			return this.buttonDropdownIconName && this.buttonDropdownIconName !== 'ply-element-transparent';
		},
		isFormValid() {
			return this.hasIcon;
		},
	},
	data() {
		return {
			isLoading: false,
			tooltip: '',
			iconColor: '',
			iconName: '',
			mainScreenText: '',
		};
	},
	created() {
		this.tooltip = this.buttonDropdown.tooltip_text;
		this.iconColor = this.buttonDropdown.icon_color;
		this.iconName = this.buttonDropdown.icon_name;
		this.mainScreenText = this.buttonDropdown.main_screen_text;
	},
	methods: {
		...mapActionsShorthand({ updateButtonDropdown }),
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		async save() {
			this.isLoading = true;
			try {
				await this.updateButtonDropdown({
					id: this.buttonDropdownId,
					data: {
						icon_name: this.iconName,
						icon_color: this.iconColor,
						tooltip_text: this.tooltip,
						main_screen_text: this.mainScreenText,
					},
				});
				this.close();
			} catch {
				this.$toast.error('Something went wrong, please try again later');
			} finally {
				this.isLoading = false;
			}
		},
	},
};
</script>
<style scoped lang="scss">
.dialog-content {
	height: 586px;
	background: var(--white);
}
.rounded {
	border-radius: 8px !important;
}
h4 {
	font-weight: 500;
}
.design {
	letter-spacing: 0px;
	color: #4d4c51;
	font-weight: bold;
}
.save-button {
	width: 155px !important;
	height: 38px !important;
	font-size: 13px !important;
	color: #ffffff !important;
	border-radius: 6px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	background: #6761ef !important;
	&.disabled {
		border-color: transparent !important;
	}
}
.tooltip {
	::v-deep {
		.text-area-container {
			width: 100%;
		}
	}
}
</style>
